/*
  Live status, 2026-10-04. Whatnot gives this site no feed, so "live" is the schedule: Alan streams
  seven days a week at 6pm Pacific (entity CLAUDE.md). The clock is read in America/Los_Angeles, so
  daylight saving and the visitor's own timezone do not matter.

  SHOW_HOURS is how long a show counts as live. 3 is a default, not a measured figure: change it here
  once Alan says how long the show runs. Too long claims LIVE NOW over a finished show, which is worse
  than too short, so round down. See snippets/scpt-live.liquid for the markup.
*/
(function () {
  if (window.scptLive) return;
  var START_MINUTE = 18 * 60;
  var SHOW_HOURS = 3;
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' });
  } catch (e) { return; }

  function liveNow() {
    var h = 0, m = 0;
    fmt.formatToParts(new Date()).forEach(function (p) {
      if (p.type === 'hour') h = +p.value % 24;
      if (p.type === 'minute') m = +p.value;
    });
    return ((h * 60 + m - START_MINUTE + 1440) % 1440) < SHOW_HOURS * 60;
  }

  function apply() {
    var on = liveNow();
    document.querySelectorAll('[data-scpt-live]').forEach(function (el) {
      el.classList.toggle('is-live', on);
      el.querySelectorAll('[data-scpt-live-text]').forEach(function (t) {
        if (t.dataset.idle == null) t.dataset.idle = t.textContent;
        var next = on ? t.dataset.live : t.dataset.idle;
        if (next && t.textContent !== next) t.textContent = next;
      });
    });
  }

  window.scptLive = { apply: apply, liveNow: liveNow };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  setInterval(apply, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) apply(); });
  document.addEventListener('shopify:section:load', apply);
})();
